import { CommonPopup } from 'common/components/entities/popup-new'
import { PopupInterface } from 'common/types/entities/popup-interface'
import BaseNodeChildren from 'publisher/components/ChildrenEntities'
import React from 'react'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'

export interface NewPopupProps {
  entity: PopupInterface
  closePopup?: () => void
  overflow?: string
  maxHeight?: string
}

export const PopupNew = ({ entity, closePopup }: NewPopupProps) => {
  const { background } = useThemeColor()
  const globalPopupBackgroundColor = background?.popupBackgroundColor

  return (
    <CommonPopup
      entity={entity}
      onCloseHandler={closePopup}
      showClose={entity.showClose}
      maxHeight={'calc(100vh - 40px)'}
      backgroundColor={entity.background || globalPopupBackgroundColor}
      mobileBackgroundColor={
        entity.mobileBackground || globalPopupBackgroundColor
      }
    >
      {!!entity?.childIds?.length && (
        <BaseNodeChildren childIds={entity.childIds} />
      )}
    </CommonPopup>
  )
}
